module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Healthnex","short_name":"Healthnex","description":"Healthnex — practice management platform for Australian Allied Health.","start_url":"/","background_color":"#ffffff","theme_color":"#3CA021","display":"standalone","icon":"src/images/logo-mini.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"61c01c256318cad0257283820614deaa"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
